import { Box, Badge } from "@mui/material"
import MyButton from "../MuiReusableComponents/MuiButton/buttonMUI"
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { MyFilterBox } from "./moduleAddAndFilterStyle";


const FilterAndAddBar = ({
  setCollapseFilterControl,
  filterStatus,
  collapseFilterControl,
  onclickFilter,
  onClickAdd,
  filterName,
  showFilterName = true,
  AddButtonName,
  onClickRunPayroll,
  Payroll,
  showAddButton = true
}) => {

  return <>
    <MyFilterBox>
      <Box className="topBox">
        <Box className="box1">
          <Badge
            color="secondary"
            variant={filterStatus ? "dot" : "standard"}
          >
            {showFilterName && (
              <MyButton
                size="small"
                title={`${filterName}`}
                startIcon={<FilterAltIcon />}
                variant="contained"
                onClick={onclickFilter}
              >
                {filterName}
              </MyButton>
            )}
          </Badge>
        </Box>
        {showAddButton && (
          <Box>
            <MyButton
              size="small"
              variant="contained"
              onClick={onClickAdd}
              title={`${AddButtonName}`}
            >
              {AddButtonName}
            </MyButton>
          </Box>
        )}

      </Box>
    </MyFilterBox>
  </>

}

export default FilterAndAddBar